var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13.334L17.5 10.0007M17.5 10.0007L14.1667 6.66732M17.5 10.0007L5.83333 10.0006M10.8333 13.334V14.1673C10.8333 15.548 9.71405 16.6673 8.33333 16.6673H5C3.61929 16.6673 2.5 15.548 2.5 14.1673V5.83398C2.5 4.45327 3.61929 3.33398 5 3.33398H8.33333C9.71405 3.33398 10.8333 4.45327 10.8333 5.83398V6.66732",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e002c05c015654d7c142e685daafeaf1.svg";
export { ForwardRef as ReactComponent };